import "./assets/main.css";

import Appsignal from "@appsignal/javascript";
import { plugin as pathDecoratorPlugin } from "@appsignal/plugin-path-decorator";
import { errorHandler } from "@appsignal/vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";
import App from "./App.vue";
import { configGateway, type Config } from "./gateways/configGateway";
import router from "./router";
import { reloadOnStaleChunk } from "./utils/reloadOnStaleChunk";

declare module "vue" {
  interface ComponentCustomProperties {
    $config: Config;
  }
}

let config: Config;

try {
  config = await configGateway.getConfig();
} catch {
  document.getElementById("app")!.innerHTML =
    "<p>Verbindung zum Server fehlgeschlagen. Bitte Seite neu laden.</p>";
  throw new Error("Could not load settings");
}

const app = createApp(App);

// Registered before mounting, so the initial route's lazy chunks are covered.
reloadOnStaleChunk();

if (config.appSignalApiKey !== undefined) {
  const appsignal = new Appsignal({
    key: config.appSignalApiKey,
    revision: import.meta.env.VITE_APP_REVISION,
  });

  appsignal.use(pathDecoratorPlugin());

  app.config.errorHandler = errorHandler(appsignal, app);
}

app.config.globalProperties.$config = config;

app.use(router);
app.use(VueQueryPlugin);
app.mount("#app");
